// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
body {
  font-family: "Poppins", sans-serif;
  background-color: #fff;
}
.container {
  max-width: 80%;
  margin: auto;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
a {
  text-decoration: none;
  color: #000;
  text-transform: capitalize;
}
ul {
  list-style-type: none;
}
button {
  border-radius: 5px;
  padding: 17px 30px;
  background:  #5cc6d0;
  border: none;
  color: #fff;
  cursor: pointer;
  font-weight: bold;
}
button i {
  margin-right: 5px;
}
.heading {
  text-align: center;
  width: 60%;
  margin: auto;
}
.heading h1 {
  color: #2d3954;
  font-weight: 600;
  text-transform: capitalize;
  font-size: 35px;
}
.heading p {
  color: #72809d;
}
textarea,
input {
  border: none;
  outline: none;
  background: none;
}
.background {
  padding: 80px 0;
  position: relative;
  background: #f7f9fc;
}

.grid5 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 30px;
}

label {
  color: #2d3954;
  font-size: 14px;
}

.mtop {
  margin-top: 50px;
}

h4 {
  font-weight: 500;
  margin-top: 10px;
}
.shadow {
  box-shadow: 0 0 20px 0 rgb(112 121 138 / 18%);
}
.padding {
  padding: 80px 0;
}
.grid3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 30px;
}
img {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.btn2 {
  border-radius: 50px;
  font-size: 20px;
}
.grid4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 30px;
}
.btn3 {
  background: #ff6922;
  border-radius: 50px;
}
.btn4 {
  background-color: #000;
  color: #fff;
}
.btn5 {
  border-radius: 50px;
  padding: 20px 40px;
  color: #27ae60;
  font-size: 20px;
  font-weight: 400;
  border: 5px solid #27ae601f;
  background: #fff;
}
.back {
  height: 40vh;
  position: relative;
}

.back img {
  height: 40vh;
  position: absolute; 
  top: 0;
  left: 0;  
  z-index: -1;
  object-fit: cover;
}
.back::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 40vh;
  background: rgba(17, 40, 72, 0.629);
  z-index: -1;
}
.back .container {
  color: #fff;
  padding: 120px 0;
}
.back h1 {
  font-size: 40px;
  font-weight: 500;
}
.mb {
  margin-bottom: 80px;
}
@media screen and (max-width: 800px) {
  .grid4,
  .grid3,
  .grid5 {
    grid-template-columns: repeat(2, 1fr);
  }
  .heading {
    width: 100%;
  }
  .container {
    max-width: 90%;
  }
  .back::after,
  .back img,
  .back {
    height: 30vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/Dashboard/back/back.css"],"names":[],"mappings":"AACA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,WAAW;AACb;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;;;IAGE,qCAAqC;EACvC;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;;;IAGE,YAAY;EACd;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800;900&display=swap\");\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\nbody {\n  font-family: \"Poppins\", sans-serif;\n  background-color: #fff;\n}\n.container {\n  max-width: 80%;\n  margin: auto;\n}\n\n.flex {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\na {\n  text-decoration: none;\n  color: #000;\n  text-transform: capitalize;\n}\nul {\n  list-style-type: none;\n}\nbutton {\n  border-radius: 5px;\n  padding: 17px 30px;\n  background:  #5cc6d0;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  font-weight: bold;\n}\nbutton i {\n  margin-right: 5px;\n}\n.heading {\n  text-align: center;\n  width: 60%;\n  margin: auto;\n}\n.heading h1 {\n  color: #2d3954;\n  font-weight: 600;\n  text-transform: capitalize;\n  font-size: 35px;\n}\n.heading p {\n  color: #72809d;\n}\ntextarea,\ninput {\n  border: none;\n  outline: none;\n  background: none;\n}\n.background {\n  padding: 80px 0;\n  position: relative;\n  background: #f7f9fc;\n}\n\n.grid5 {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  grid-gap: 30px;\n}\n\nlabel {\n  color: #2d3954;\n  font-size: 14px;\n}\n\n.mtop {\n  margin-top: 50px;\n}\n\nh4 {\n  font-weight: 500;\n  margin-top: 10px;\n}\n.shadow {\n  box-shadow: 0 0 20px 0 rgb(112 121 138 / 18%);\n}\n.padding {\n  padding: 80px 0;\n}\n.grid3 {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 30px;\n}\nimg {\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n.btn2 {\n  border-radius: 50px;\n  font-size: 20px;\n}\n.grid4 {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-gap: 30px;\n}\n.btn3 {\n  background: #ff6922;\n  border-radius: 50px;\n}\n.btn4 {\n  background-color: #000;\n  color: #fff;\n}\n.btn5 {\n  border-radius: 50px;\n  padding: 20px 40px;\n  color: #27ae60;\n  font-size: 20px;\n  font-weight: 400;\n  border: 5px solid #27ae601f;\n  background: #fff;\n}\n.back {\n  height: 40vh;\n  position: relative;\n}\n\n.back img {\n  height: 40vh;\n  position: absolute; \n  top: 0;\n  left: 0;  \n  z-index: -1;\n  object-fit: cover;\n}\n.back::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 40vh;\n  background: rgba(17, 40, 72, 0.629);\n  z-index: -1;\n}\n.back .container {\n  color: #fff;\n  padding: 120px 0;\n}\n.back h1 {\n  font-size: 40px;\n  font-weight: 500;\n}\n.mb {\n  margin-bottom: 80px;\n}\n@media screen and (max-width: 800px) {\n  .grid4,\n  .grid3,\n  .grid5 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .heading {\n    width: 100%;\n  }\n  .container {\n    max-width: 90%;\n  }\n  .back::after,\n  .back img,\n  .back {\n    height: 30vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
